import { InjectionToken } from '@angular/core';

import { NSamples } from '@df/samples/samples.namespace';

export const SAMPLES_CONFIG = new InjectionToken<NSamples.IConfig>('SAMPLES_CONFIG');
